import { create } from "zustand";
var useIndividualStore = create(function (set) { return ({
    setEmail: function (email) { return set({ email: email }); },
    setEducationalInstitutionData: function (educationalInstitutionData) {
        return set({ educationalInstitutionData: educationalInstitutionData });
    },
    setAddressData: function (addressData) { return set({ addressData: addressData }); },
    setRepresentativeOfInstitutionData: function (representativeOfInstitutionData) {
        return set({ representativeOfInstitutionData: representativeOfInstitutionData });
    },
    setModalitiesRegisteredData: function (modalitiesRegisteredData) {
        return set({ modalitiesRegisteredData: modalitiesRegisteredData });
    },
    reset: function () {
        return set({
            email: undefined,
            educationalInstitutionData: undefined,
            addressData: undefined,
            representativeOfInstitutionData: undefined,
            modalitiesRegisteredData: undefined,
        });
    },
}); });
export default useIndividualStore;
